module.exports = __webpack_public_path__ + "img/key-icon.c2da103c.svg";